import React from 'react'
import { Provider } from 'mobx-react'

import rootStoreInstance from '../stores/rootStoreInstance'
import ErrorBoundary from '../../Shared/ErrorBoundary'

import LastVerified from './LastVerified'

const StateFulLastVerified = props => {
  rootStoreInstance.setInitialDataLastVerified(props)

  return (
    <ErrorBoundary>
      <Provider store={rootStoreInstance}>
        <LastVerified />
      </Provider>
    </ErrorBoundary>
  )
}

export default StateFulLastVerified
